



































































import { getDownloadUrl } from '@/apps/courseware/model/api'
import { Component, Vue, Prop, Provide, Emit } from 'vue-property-decorator'
import Office from '../../../apps/courseware/components/Office.vue'
import Pdf from '../../../apps/courseware/components/Pdf.vue'

@Component({
  components: {
    Pdf,
    Office
  }
})
export default class BookPaperItem extends Vue {
  public avatar = {
    shape: 'square',
    size: 'large'
  }
  @Prop() public docId!: string
  @Prop() public loading!: boolean
  @Prop() public data!: any
  @Prop() public type!: string
  @Prop({
    default() {
      return true
    }
  })
  public moreInfo!: boolean
  @Prop({
    default() {
      return ''
    }
  })
  public from!: string
  // 弹窗宽度
  public width = 800
  // 预览弹窗
  public visible = false
  // 预览数据
  public dataInfo = {}
  // 过期时间
  public timeout = false
  public mounted() {
    // 过期时间2小时,7200000s
    setTimeout(() => this.timeout = true, 7200000)
  }
  // 下载文件
  public async clickDownloadTip(d: any) {
    let res: any = await getDownloadUrl({
      doc_id: this.docId,
      idx: d.idx,
      subject_id: this.subjectId
    })
    if (res.success) {
      window['sensors'].track('TIKU_Download', {
        proSource: this.from,
        content: '课件',
        paper_subject: this.data.subject_text || '',
        is_not: ''
      })
      window.open(res.data.download_urls)
    } else {
      this.$message.error(res.msg)
    }
  }
  // 预览
  public preview(d: any) {
    // 判断是否过期
    if (this.timeout) {
      this.$message.warning('您在当前页面停留时间过长，请刷新页面')
      return
    }
    if (d.ext === 'mp3') {
      this.width = 480
    } else {
      this.width = 800
    }
    this.visible = true
    this.dataInfo = d
  }
  // judgeMp4s
  public judgeMp4s(item) {
    let whiteList = ['.mp4', '.ogg', '.webm']
    if (!item) return
    return whiteList.some((val) => {
      return item.includes(val)
    })
  }
  // judgeMp3s
  public judgeMp3s(item) {
    let whiteList = ['.mp3', '.wav', '.ogg', '.acc', '.webm']
    if (!item) return
    return whiteList.some((val) => {
      return item.includes(val)
    })
  }
  // judgePics
  public judgePics(item) {
    let whiteList = ['.jpg', '.png', '.gif', '.jpeg', '.svg', ';base64']
    if (!item) return
    return whiteList.some((val) => {
      return item.includes(val)
    })
  }
  // judgeOffice
  public judgeOffice(item) {
    let whiteList = ['.doc', '.docx', '.xls', '.xlsx']
    if (!item) return
    return whiteList.some((val) => {
      return item.includes(val)
    })
  }
  // 学科id
  public get subjectId() {
    return this.$store.state.subject.value || this.$route.query.subject_id || ''
  }
  public get date() {
    return this.$route.query.date || ''
  }
  public get userName() {
    return this.$store.state.user_info && this.$store.state.user_info.nickname
  }
  // 试卷id
  private get _id() {
    return this.data.id || this.data.paper_id
  }
  // 展示文件icon
  public imageUrl(data) {
    // word
    if (['doc', 'docx'].includes(data)) {
      return require(`@/assets/svg/word.svg`)
      // ppt
    } else if (['ppt', 'pptx'].includes(data)) {
      return require(`@/assets/svg/ppt.svg`)
      // mp4
    } else if (['mp4', 'wmv', 'rmvb'].includes(data)) {
      return require(`@/assets/svg/mp4.svg`)
      // mp3
    } else if (['wav', 'mp3'].includes(data)) {
      return require(`@/assets/svg/mp3.svg`)
      // 文件类型
    } else if (data) {
      try {
        return require(`@/assets/svg/${data}.svg`)
      } catch (e) {
        return require(`@/assets/svg/file.svg`)
      }
      // eslint-disable-next-line no-unreachable
      return require(`@/assets/svg/${data}.svg`)
      // 兼容类型
    } else {
      return require(`@/assets/svg/file.svg`)
    }
  }
  // 更新日期
  public getDate(val) {
    if (val) {
      return val
    } else {
      return this.date
    }
  }
}
